import { useCallback, useEffect, useState } from 'react';

import { DocumentPreviewDialog } from '@/components/pages/documents/document-preview-dialog';
import { DownloadTaskFile } from '@/task-manager/api/mutations/download-task-file';
import { ListTaskFiles } from '@/task-manager/api/queries/list-task-files';
import type { TaskDetails } from '@/task-manager/entities/task-details';
import type { TaskFile } from '@/task-manager/entities/task-file';

export type DocumentPreviewProps = {
  task: TaskDetails;
  fileId?: string;
  onClose?: () => void;
};
export function DocumentPreview({
  fileId,
  task,
  onClose,
}: DocumentPreviewProps) {
  const { mutateAsync: downloadTaskFile } = DownloadTaskFile.useMutation();
  const [previewFile, setPreviewFile] = useState<File | undefined>();

  const taskFiles = ListTaskFiles.useQuery(
    { task },
    { refetchInterval: 10_000 },
  );

  const document = taskFiles.data?.files.find((f) => f.id === fileId);

  const previewOrDownload = useCallback(
    async function (file: TaskFile) {
      const result = await downloadTaskFile({ task, file });
      setPreviewFile(result.file);
    },
    [downloadTaskFile, setPreviewFile, task],
  );

  useEffect(
    function () {
      if (document) {
        previewOrDownload(document);
      }
    },
    [document, previewOrDownload],
  );

  return document ? (
    <DocumentPreviewDialog
      open={Boolean(previewFile)}
      file={previewFile}
      document={document}
      onClose={function () {
        setPreviewFile(undefined);
        onClose?.();
      }}
    />
  ) : null;
}
